import { useId } from "react";

export function HelpTip({ text, label = "More information", align = "end" }: { text: string; label?: string; align?: "start" | "end" }) {
  const tooltipId = useId();
  return <span className={`help-tip align-${align}`}>
    <button type="button" aria-label={label} aria-describedby={tooltipId} title={text}>i</button>
    <span id={tooltipId} role="tooltip">{text}</span>
  </span>;
}
